import type { WritableSignal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

export const { provide: providePreviewAskEnabled, inject: injectPreviewAskEnabled } =
  createProviderToken<WritableSignal<boolean>>('HRAssistantPreviewAskEnabled')();
